import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

/**
 * Component for rendering markdown content with loading state
 * @param {Object} props - Component props
 * @param {string} props.content - Markdown content to render
 * @param {string} props.className - Optional CSS class name
 * @returns {JSX.Element} - Rendered component
 */
function MarkdownContent({ content, className = '' }) {
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Set loading to false once content is available
    if (content !== undefined) {
      // Small delay to prevent flickering for very fast loads
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [content]);
  
  if (content === undefined) return null;
  
  return (
    <div className={`markdown-content ${className}`}>
      {isLoading ? (
        <div className="markdown-loading">
          <div className="loading-spinner"></div>
          <span>Loading content...</span>
        </div>
      ) : (
        <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
          {content || ''}
        </ReactMarkdown>
      )}
    </div>
  );
}

export default MarkdownContent;
